import { render, staticRenderFns } from "./ProductChange.vue?vue&type=template&id=378908c6"
import script from "./ProductChange.vue?vue&type=script&lang=js"
export * from "./ProductChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports